import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useMemo } from 'react';
import { ClientContactsApiAdapter, CreateTeamContactRequest } from '../adapters/ClientContactsApiAdapter';

export const useCreateTeamContact = (teamId: number) => {
    const queryClient = useQueryClient();

    const apiAdapter = useMemo(() => {
        const httpClient = createHttpClient(apiClientWH);
        return new ClientContactsApiAdapter(httpClient);
    }, []);

    const mutation = useMutation({
        mutationFn: (data: CreateTeamContactRequest) =>
            apiAdapter.createContact(teamId, data),
        onSuccess: () => {
            // Invalidar la cache de contactos para refrescar los datos
            queryClient.invalidateQueries({ queryKey: ['team-contacts', teamId] });
            // También invalidar la cache del cliente por si acaso
            queryClient.invalidateQueries({ queryKey: ['client', teamId] });
        },
    });

    return {
        createContact: mutation.mutate,
        createContactAsync: mutation.mutateAsync,
        isPending: mutation.isPending,
        isSuccess: mutation.isSuccess,
        error: mutation.error,
        reset: mutation.reset,
    };
};

